import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainLayout from './components/layout';
import DashboardPage from './pages/Dashboard/Dashboard';
import { ThemeProvider } from '@emotion/react';
import { createTheme } from '@mui/material';
import { MainContextProvider } from './context/mainContext';
import { createWeb3Modal, defaultConfig } from '@web3modal/ethers/react'
import { GlobalStateProvider } from "@reactivers/use-global-state";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
// import walletConnectLogo from "./assets/images/wallet-connect.jpg";
// import coinbaseLogo from "./assets/images/coin/Coinbase.svg";
// import ethereumLogo from "./assets/images/coin/eth-1.png";
import logo from "../src/assets/images/logo.png";
import CreateCurvePage from './pages/createCurvs';
import MyCurvsPage from './pages/myCurvs';
import DetailPage from './pages/DetailsPage/DetailsPage';
import DocumentPage from './pages/doc';
// import { socket } from './utils/socket';
import { useChains } from './hooks/config';
import { useEffect, useRef, useState } from 'react';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
  typography: {
    fontFamily: "Inter",
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 800,
      md: 900,
      lg: 1200,
      xl: 1536,
    }
  }
});

const projectId = '07efe273ec05006951c30c4399c2e9b9';

// test sds

const metadata = {
  name: 'Ethism',
  description: '',
  url: '', // origin must match your domain & subdomain
  icons: [logo]
};

function App() {
  const { data: chains } = useChains()
  const web3Ref = useRef(false)
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    if (!chains || chains.length === 0)
      return
    if (web3Ref.current)
      return
    const defaultChain = chains[0]
    const ethersConfig = defaultConfig({
      metadata,
      enableEIP6963: true, // true by default
      enableInjected: false, // true by default
      enableCoinbase: false, // true by default
      rpcUrl: defaultChain.rpcUrl, // used for the Coinbase SDK
      defaultChainId: defaultChain.chainId, // used for the Coinbase SDK
    });
    createWeb3Modal({
      ethersConfig,
      chains: chains.map(chain => ({
        name: chain.name,
        chainId: chain.chainId,
        currency: chain.currency,
        rpcUrl: chain.rpcUrl,
        explorerUrl: chain.explorerUrl,
      })),
      // chainImages: {
      //   1: ethereumLogo
      // },
      // connectorImages: {
      //   coinbaseWallet: coinbaseLogo,
      //   walletConnect: walletConnectLogo,
      // },
      projectId,
      // allWallets: 'HIDE'
      // enableAnalytics: true, // Optional - defaults to your Cloud configuration
    })
    web3Ref.current = true
    setLoading(false)
  }, [chains])

  return (
    <div className="App">
      {
        !isLoading
        ? <MainContextProvider>
          <ToastContainer theme="dark" position="bottom-right" />
          <ThemeProvider theme={darkTheme}>
            {/* @ts-ignore */}
            <GlobalStateProvider>
              <BrowserRouter>
                <Routes>
                  <Route element={<MainLayout />}>
                    <Route path='/' element={<DashboardPage />} />
                    <Route path='/ref/:code' element={<DashboardPage />} />
                    {/* <Route path='/leaderboard' element={<LeaderboardPage />} /> */}
                    <Route path='/create' element={<CreateCurvePage />} />
                    <Route path='/my_tokens' element={<MyCurvsPage />} />
                    <Route path='/:chain/:id' element={<DetailPage />} />
                    <Route path='/privacy' element={<DocumentPage content="privacy" />} />
                    <Route path='/terms' element={<DocumentPage content="terms" />} />
                    <Route path='/docs' element={<DocumentPage content="docs" />} />
                    <Route path='/support' element={<DocumentPage content="support" />} />
                    {/* <Route path='/profile/:address' element={<ProfilePage />} />
                    <Route path='/profile/:address/:tab' element={<ProfilePage />} />
                    <Route path='/admin' element={<AdminPage />} /> */}
                  </Route>
                </Routes>
              </BrowserRouter>
            </GlobalStateProvider>
          </ThemeProvider>
        </MainContextProvider>
        : <>Loading</>
      }
    </div>
  );
}

export default App;